import React from 'react'

function SendMessage() {
  return (
    <div>
                <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.75106 10.2839L8.19459 16.2261C8.35453 16.8845 8.89708 17.3805 9.56709 17.4809C10.2371 17.5814 10.9012 17.2662 11.2472 16.6837L17.6798 5.85101C17.9857 5.33589 17.9916 4.69622 17.6953 4.17555C17.3989 3.65488 16.8459 3.33333 16.2468 3.33334H3.75269C3.07595 3.33332 2.46639 3.74252 2.21012 4.36886C1.95384 4.99519 2.10174 5.71431 2.5844 6.18868L6.75106 10.2839Z"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M17.6922 4.17303L6.75 10.2839"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
    </div>
  )
}

export default SendMessage